// GENERATED by scripts/build-icons.mjs from icons/mail.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Mail = createIcon('mail', [
  ['path', { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }],
  ['rect', { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
])
